
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11611',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11611",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.449",
  "dashboard-client-types": "static-1.240",
  "data-fetching-client": "static-1.9493",
  "foundations-components": "static-1.7559",
  "foundations-components-legacy": "static-1.584",
  "foundations-theming": "static-1.4227",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7821",
  "hub-http-shared-msw-handlers": "static-1.9517",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11248",
  "I18n": "static-7.1574",
  "jasmine-runner": "static-1.6288",
  "marketplace-storefront-base": "static-1.11671",
  "quartz": "static-1.6756",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16468",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2678",
  "reporting-testing-lib": "static-1.8530",
  "settings-ui-lib": "static-1.12338",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6767",
  "ui-addon-i18n": "static-1.10959",
  "ui-addon-react-router-dom": "static-1.9362",
  "unified-auth": "static-1.236",
  "unified-auth-core-lib": "static-1.517",
  "usage-tracker": "static-1.7151",
  "usage-tracker-core": "static-1.7001",
  "customer-data-property-utils": "static-1.7894",
  "history": "static-4.47",
  "hub-http": "static-1.6036",
  "integrations-lib": "static-1.15477",
  "marketplace-ui-common": "static-1.18998",
  "property-management-iframe": "static-1.12411",
  "quartz-config": "static-1.534",
  "quartz-core": "static-1.5975",
  "quartz-routing": "static-1.186",
  "quick-fetch": "static-1.3750",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4450",
  "ts-schema": "static-1.3919",
  "ui-universal-auth": "static-1.8722",
  "UIComponents": "static-3.8195",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3244",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3033",
  "quartz-webpack": "static-1.2980",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3828",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4652",
  "foundations-theming-specialty": "static-1.1943",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9243",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5188",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1260",
  "ui-fonts": "static-1.510",
  "ui-images": "static-2.1096",
  "bend-plugin-foundations-theming": "static-1.2710",
  "foundations-theming-base": "static-1.3212",
  "stylex": "static-1.28",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2932",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4142",
  "ai-components-ui-library": "static-1.8397",
  "ai-rendering-library": "static-1.9357",
  "chirp-fetch": "static-1.1698",
  "connections-embed-lib": "static-1.659",
  "copilot-toolkit": "static-1.10580",
  "laboratory-lib": "static-3.6976",
  "marketplace-embed": "static-1.21522",
  "marketplace-ui-details": "static-1.8894",
  "marketplace-ui-reviews": "static-1.18954",
  "marketplace-ui-tracking": "static-1.13169",
  "sanitize-text": "static-1.7960",
  "ui-addon-video-player": "static-1.8512",
  "usage-tracker-multi": "static-1.5565",
  "usage-tracker-session-replay": "static-1.4837",
  "wootric-nps": "static-1.6800",
  "apollo-link-hub-http": "static-2.4468",
  "immer": "static-1.33",
  "immerable": "static-1.3971",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66597",
  "cssUtils": "static-1.736",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11556",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10025",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10187",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7141",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17531",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4337",
  "foundations-components-test-utils": "static-1.5042",
  "quartz-i18n": "static-1.431",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3548",
  "customer-data-objects": "static-1.7465",
  "property-translator": "static-1.5228",
  "frontend-preferences-client": "static-1.7740",
  "hs-promise-utils": "static-1.5409",
  "hubspot-apollo-client": "static-1.4697",
  "integrations-error-boundary-lib": "static-1.12892",
  "integrations-tracking-lib": "static-1.5405",
  "native-integrations-shared-strings": "static-1.7604",
  "reselect": "static-2.16",
  "sanitize": "static-1.4290",
  "superstore": "static-1.4586",
  "ui-shepherd-react": "static-3.9963",
  "ai-settings-ui-library": "static-1.7504",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4493",
  "immutable-less": "static-1.4470",
  "marketplace-ui-client-types": "static-1.16405",
  "nav-meta": "static-1.28965",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10053",
  "ui-addon-upgrades": "static-9.17682",
  "inbound-db-properties-service-client": "static-1.3690",
  "property-management-common": "static-1.4698",
  "ui-addon-iframeable": "static-1.8863",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.431",
  "quartz-head": "static-1.421",
  "quartz-test": "static-1.431",
  "quartz-tracking": "static-1.135",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2968",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20400",
  "ContentUtils": "static-1.67674",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2303",
  "customer-data-filters-ui": "static-1.38966",
  "customer-data-objects-ui-components": "static-1.12825",
  "customer-data-reference-ui-components": "static-1.12962",
  "embedded-academy-lib": "static-1.13608",
  "ExportDialog": "static-6.10203",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40703",
  "reporting-snowflake": "static-1.55215",
  "reporting-ui-components": "static-2.63868",
  "reporting-visualizations": "static-1.58673",
  "ui-addon-teams": "static-1.21264",
  "magpie-lib": "static-1.5410",
  "magpie-types": "static-1.4870",
  "simple-logging-lib": "static-1.2866",
  "navigation-components": "static-1.17328",
  "ai-studio-lib": "static-1.11048",
  "developer-experience-shared-components": "static-1.10296",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7808",
  "ui-tool-access": "static-1.9961",
  "usage-based-billing-components-lib": "static-1.8055",
  "usage-tracker-anonymous": "static-1.5568",
  "usage-tracker-public": "static-1.6962",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3435",
  "persist-promise": "static-1.3524",
  "reference-resolvers": "static-1.7976",
  "ui-extensibility-client-types": "static-1.3760",
  "hubspot-apollo-cache": "static-1.156",
  "universal-page-editor-lib": "static-1.2816",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2233",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4885",
  "purchase-motions-components": "static-1.5505",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1367",
  "crm-component-utils": "static-1.38524",
  "crm-properties-common-lib": "static-1.5688",
  "framework-data-schema-resolvers": "static-1.6689",
  "reference-resolvers-lite": "static-1.7910",
  "navigation-messaging": "static-1.6655",
  "hubspotter-http-shared-msw-handlers": "static-1.9515",
  "cms-field-types": "static-1.4622",
  "content-icons-ui": "static-1.2158",
  "conversations-skeleton-state": "static-1.7064",
  "crm-message-bus": "static-1.42415",
  "customer-data-filters-ui-msw-helpers": "static-1.21401",
  "customer-data-ui-utilities": "static-1.9639",
  "FormUrlGenerator": "static-2.4544",
  "framework-builder-read-service-client": "static-1.3848",
  "framework-data-schema-quick-fetch": "static-1.6594",
  "multi-account-reference-resolvers": "static-1.789",
  "onboarding-tours": "static-1.16287",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13106",
  "academy-common-lib": "static-1.13068",
  "content-assistance-lib": "static-1.7474",
  "dashboard-lib": "static-1.80696",
  "file-manager-components": "static-1.22950",
  "getting-started-shared-tasks": "static-1.17934",
  "hubspot-prosemirror": "static-1.17652",
  "hubspot-prosemirror-plugins": "static-1.17644",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19502",
  "share-with-third-party-component-lib": "static-1.8508",
  "ui-addon-draggable": "static-3.4581",
  "ui-asset-management-lib": "static-1.10731",
  "ui-business-units-lib": "static-1.8845",
  "user-context": "static-1.4915",
  "growth-payments-core": "static-1.24776",
  "reporting-plugins": "static-1.10005",
  "reporting-reports": "static-1.66275",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.541",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28892",
  "react-codemirror": "static-1.10443",
  "apps-service-types": "static-1.3693",
  "oauth-service-types": "static-1.4063",
  "onboarding-scopes": "static-1.6279",
  "onboarding-tours-client": "static-1.4501",
  "platform-infra-nav-components": "static-1.7507",
  "subscription-experience-data-types": "static-1.14607",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8617",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2173",
  "purchase-motions-api": "static-1.5508",
  "signup-constants": "static-1.18450",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43572",
  "crm-actions": "static-1.6121",
  "crm-cards-data": "static-1.1249",
  "crm-cards-sdk": "static-1.42970",
  "customer-data-properties": "static-1.50848",
  "customer-data-properties-shared-msw-handlers": "static-1.8844",
  "customer-data-tracking": "static-1.6698",
  "conditional-properties-service-client": "static-1.3638",
  "crm-pipelines-api-client-types": "static-1.3979",
  "multi-currency-client-types": "static-1.3532",
  "external-options-client-types": "static-1.3999",
  "react-dnd-compat": "static-1.4436",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5175",
  "growth-onboarding-confetti": "static-1.2888",
  "growth-onboarding-next-action-utils": "static-1.1335",
  "onboarding-tours-utils": "static-1.353",
  "ui-shepherd-tracker": "static-1.7344",
  "academy-service-client": "static-1.3496",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27989",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8200",
  "video-components-external": "static-1.10621",
  "video-data-lib": "static-1.34279",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8384",
  "payment-link-components": "static-1.22985",
  "ui-addon-emoji-picker": "static-1.9704",
  "EmailSignatureEditor": "static-1.23949",
  "viral-links-lib": "static-1.6851",
  "data-token-picker": "static-1.16073",
  "FileManagerLib": "static-1.38590",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5060",
  "getting-started-shared-tasks-store": "static-1.17052",
  "campaign-roi-lib": "static-1.8329",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.209",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91277",
  "crm-links": "static-1.6083",
  "customer-data-sidebar": "static-2.45466",
  "enrichment-properties-lib": "static-1.15099",
  "crm-fe-perf": "static-1.22722",
  "calling-global-api": "static-1.63740",
  "calling-internal-common": "static-1.31111",
  "calling-lifecycle-internal": "static-1.65122",
  "calling-lifecycle-messages": "static-1.57416",
  "commerce-products-lib": "static-1.8910",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.494",
  "inbounddb-objects-service-types": "static-1.4063",
  "meetings-icalendar-utils-lib": "static-1.449",
  "object-builder-ui-client": "static-1.48046",
  "pipeline-validation-client-types": "static-1.3804",
  "property-value-citations": "static-1.1462",
  "pulse": "static-1.332",
  "smart-property-lib": "static-1.5981",
  "tiered-pricing": "static-1.853",
  "ui-addon-form-validation": "static-1.10810",
  "growth-onboarding-next-action-components": "static-1.1363",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6399",
  "content-media-composition-data-lib": "static-1.11523",
  "content-media-compositions": "static-2.15530",
  "media-bridge-lib": "static-1.18596",
  "commerce-tours-lib": "static-1.5745",
  "growth-onboarding-reliability": "static-1.4902",
  "sales-checkout-service-client": "static-1.3484",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21338",
  "sales-email-signature-service-client": "static-1.3660",
  "audio-components": "static-1.5637",
  "FileManagerCore": "static-1.38449",
  "FileManagerImages": "static-1.36101",
  "video-components": "static-1.12624",
  "crm_universal": "static-1.21691",
  "customer-data-email": "static-1.17701",
  "calling-error-reporting": "static-1.31117",
  "card-payment-highlight-lib": "static-1.36549",
  "card-subscription-highlight-lib": "static-1.38905",
  "commerce-billing-lib": "static-1.18548",
  "commerce-contract-lib": "static-1.11256",
  "customer-data-content": "static-1.26905",
  "invoices-highlight-card-lib": "static-1.54087",
  "orders-highlight-card-lib": "static-1.20913",
  "products-highlight-card-lib": "static-1.17194",
  "project-storage": "static-1.4549",
  "quotes-highlight-card-lib": "static-1.71276",
  "breeze-intelligence-kit": "static-1.5346",
  "crm-source-interpretation-lib": "static-1.5146",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9600",
  "policy-lib": "static-1.6603",
  "shared-worker-versioning": "static-1.10854",
  "calling-usage-tracker": "static-1.6356",
  "voice-sms-access-library": "static-1.297",
  "commerce-permissions": "static-1.575",
  "products-iframe-lib": "static-1.7365",
  "products-ui-components-shared-msw-handlers": "static-1.9899",
  "directed-graph": "static-1.755",
  "event-emitter": "static-1.763",
  "react-tinymce": "static-1.54668",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9663",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53794",
  "tinymce-plugins": "static-1.56908",
  "tinymce-themes": "static-1.55764",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4348",
  "video-embed": "static-1.35113",
  "social-insights-client-types": "static-1.21413",
  "sequences-lib": "static-1.7714",
  "ui-gdpr-components": "static-1.10163",
  "commerce-shared-components-lib": "static-1.17983",
  "commerce-subscription-lib": "static-1.36482",
  "commerce-tools-ui-lib": "static-1.9841",
  "utility-belt": "static-1.2356",
  "payments-enrollment-embed-lib": "static-1.22072",
  "products-ui-components": "static-1.39429",
  "quotes-client-types": "static-1.37365",
  "quotes-ui-lib": "static-1.79996",
  "SalesContentIndexUI": "static-3.8927",
  "accounting-integrations-ui-components": "static-1.6751",
  "invoices-ui-lib": "static-1.54103",
  "commerce-products-api": "static-1.1980",
  "SafeStorage": "static-1.4220",
  "invoices-iframe-lib": "static-1.56161",
  "quotes-modal-lib": "static-1.101953",
  "calling-orchestration-schema": "static-1.35074",
  "sales-views-client-types": "static-1.4103",
  "hub-http-contrib": "static-1.2859",
  "interframe": "static-3.4605",
  "tinymce-data": "static-1.39879",
  "ui-addon-sales-email": "static-1.5029",
  "layout-dnd-components": "static-1.12069",
  "layout-dnd-utils": "static-1.11044",
  "ui-brand-identity-lib": "static-1.13982",
  "NamespacedHubStyle": "static-2.8911",
  "outpost": "static-1.4022",
  "sequences-client-types-lib": "static-1.7571",
  "customer-data-associations": "static-1.7154",
  "framework-data-table": "static-2.11456",
  "customer-data-rte": "static-1.32488",
  "cv-backend-services": "static-1.1505",
  "growth-onboarding-empty-states": "static-1.5391",
  "InboxConnectUtils": "static-4.14271",
  "payments-post-enroll-local-storage-lib": "static-1.4930",
  "qrcode-generator": "static-1.65",
  "stripe-embedded-components": "static-1.7164",
  "commerce-tax-lib": "static-1.333",
  "property-description-translator": "static-1.3674",
  "FireAlarmUi": "static-1.4347",
  "sales-templates-service-types-lib": "static-1.4006",
  "commerce-analytics-service-client": "static-1.3472",
  "totals-ui-components": "static-1.23043",
  "ContentData": "static-1.67749",
  "layout-data-lib": "static-1.9369",
  "deal-intel-decorators": "static-1.1308",
  "tanstack-virtual": "static-1.26",
  "draft-content-plugins": "static-1.27756",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3655",
  "advanced-menus-core": "static-1.14841",
  "advanced-menus-lib": "static-1.11812",
  "ui-memberships-settings-lib": "static-1.33483",
  "deal-intel-utils": "static-1.1312",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14840",
  "simple-menus-lib": "static-1.16357"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11611",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.449",
  "dashboard-client-types": "/dashboard-client-types/static-1.240",
  "data-fetching-client": "/data-fetching-client/static-1.9493",
  "foundations-components": "/foundations-components/static-1.7559",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.584",
  "foundations-theming": "/foundations-theming/static-1.4227",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7821",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9517",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11248",
  "I18n": "/I18n/static-7.1574",
  "jasmine-runner": "/jasmine-runner/static-1.6288",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11671",
  "quartz": "/quartz/static-1.6756",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16468",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2678",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8530",
  "settings-ui-lib": "/settings-ui-lib/static-1.12338",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6767",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10959",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9362",
  "unified-auth": "/unified-auth/static-1.236",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.517",
  "usage-tracker": "/usage-tracker/static-1.7151",
  "usage-tracker-core": "/usage-tracker-core/static-1.7001",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7894",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6036",
  "integrations-lib": "/integrations-lib/static-1.15477",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18998",
  "property-management-iframe": "/property-management-iframe/static-1.12411",
  "quartz-config": "/quartz-config/static-1.534",
  "quartz-core": "/quartz-core/static-1.5975",
  "quartz-routing": "/quartz-routing/static-1.186",
  "quick-fetch": "/quick-fetch/static-1.3750",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4450",
  "ts-schema": "/ts-schema/static-1.3919",
  "ui-universal-auth": "/ui-universal-auth/static-1.8722",
  "UIComponents": "/UIComponents/static-3.8195",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3244",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3033",
  "quartz-webpack": "/quartz-webpack/static-1.2980",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3828",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4652",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1943",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9243",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5188",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1260",
  "ui-fonts": "/ui-fonts/static-1.510",
  "ui-images": "/ui-images/static-2.1096",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2710",
  "foundations-theming-base": "/foundations-theming-base/static-1.3212",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2932",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4142",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8397",
  "ai-rendering-library": "/ai-rendering-library/static-1.9357",
  "chirp-fetch": "/chirp-fetch/static-1.1698",
  "connections-embed-lib": "/connections-embed-lib/static-1.659",
  "copilot-toolkit": "/copilot-toolkit/static-1.10580",
  "laboratory-lib": "/laboratory-lib/static-3.6976",
  "marketplace-embed": "/marketplace-embed/static-1.21522",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8894",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18954",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13169",
  "sanitize-text": "/sanitize-text/static-1.7960",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8512",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5565",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4837",
  "wootric-nps": "/wootric-nps/static-1.6800",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4468",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3971",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66597",
  "cssUtils": "/cssUtils/static-1.736",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11556",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10025",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10187",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7141",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17531",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4337",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5042",
  "quartz-i18n": "/quartz-i18n/static-1.431",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3548",
  "customer-data-objects": "/customer-data-objects/static-1.7465",
  "property-translator": "/property-translator/static-1.5228",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7740",
  "hs-promise-utils": "/hs-promise-utils/static-1.5409",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4697",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12892",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5405",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7604",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4290",
  "superstore": "/superstore/static-1.4586",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9963",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7504",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4493",
  "immutable-less": "/immutable-less/static-1.4470",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16405",
  "nav-meta": "/nav-meta/static-1.28965",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10053",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17682",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3690",
  "property-management-common": "/property-management-common/static-1.4698",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8863",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.431",
  "quartz-head": "/quartz-head/static-1.421",
  "quartz-test": "/quartz-test/static-1.431",
  "quartz-tracking": "/quartz-tracking/static-1.135",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2968",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20400",
  "ContentUtils": "/ContentUtils/static-1.67674",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2303",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38966",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12825",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12962",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13608",
  "ExportDialog": "/ExportDialog/static-6.10203",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40703",
  "reporting-snowflake": "/reporting-snowflake/static-1.55215",
  "reporting-ui-components": "/reporting-ui-components/static-2.63868",
  "reporting-visualizations": "/reporting-visualizations/static-1.58673",
  "ui-addon-teams": "/ui-addon-teams/static-1.21264",
  "magpie-lib": "/magpie-lib/static-1.5410",
  "magpie-types": "/magpie-types/static-1.4870",
  "simple-logging-lib": "/simple-logging-lib/static-1.2866",
  "navigation-components": "/navigation-components/static-1.17328",
  "ai-studio-lib": "/ai-studio-lib/static-1.11048",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10296",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7808",
  "ui-tool-access": "/ui-tool-access/static-1.9961",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8055",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5568",
  "usage-tracker-public": "/usage-tracker-public/static-1.6962",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3435",
  "persist-promise": "/persist-promise/static-1.3524",
  "reference-resolvers": "/reference-resolvers/static-1.7976",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3760",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.156",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2816",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2233",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4885",
  "purchase-motions-components": "/purchase-motions-components/static-1.5505",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1367",
  "crm-component-utils": "/crm-component-utils/static-1.38524",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5688",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6689",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7910",
  "navigation-messaging": "/navigation-messaging/static-1.6655",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9515",
  "cms-field-types": "/cms-field-types/static-1.4622",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7064",
  "crm-message-bus": "/crm-message-bus/static-1.42415",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21401",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9639",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4544",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3848",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6594",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.789",
  "onboarding-tours": "/onboarding-tours/static-1.16287",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13106",
  "academy-common-lib": "/academy-common-lib/static-1.13068",
  "content-assistance-lib": "/content-assistance-lib/static-1.7474",
  "dashboard-lib": "/dashboard-lib/static-1.80696",
  "file-manager-components": "/file-manager-components/static-1.22950",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17934",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17652",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17644",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19502",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8508",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4581",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10731",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8845",
  "user-context": "/user-context/static-1.4915",
  "growth-payments-core": "/growth-payments-core/static-1.24776",
  "reporting-plugins": "/reporting-plugins/static-1.10005",
  "reporting-reports": "/reporting-reports/static-1.66275",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.541",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28892",
  "react-codemirror": "/react-codemirror/static-1.10443",
  "apps-service-types": "/apps-service-types/static-1.3693",
  "oauth-service-types": "/oauth-service-types/static-1.4063",
  "onboarding-scopes": "/onboarding-scopes/static-1.6279",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4501",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7507",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14607",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8617",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2173",
  "purchase-motions-api": "/purchase-motions-api/static-1.5508",
  "signup-constants": "/signup-constants/static-1.18450",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43572",
  "crm-actions": "/crm-actions/static-1.6121",
  "crm-cards-data": "/crm-cards-data/static-1.1249",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42970",
  "customer-data-properties": "/customer-data-properties/static-1.50848",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8844",
  "customer-data-tracking": "/customer-data-tracking/static-1.6698",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3638",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3979",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3532",
  "external-options-client-types": "/external-options-client-types/static-1.3999",
  "react-dnd-compat": "/react-dnd-compat/static-1.4436",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5175",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2888",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1335",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.353",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7344",
  "academy-service-client": "/academy-service-client/static-1.3496",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27989",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8200",
  "video-components-external": "/video-components-external/static-1.10621",
  "video-data-lib": "/video-data-lib/static-1.34279",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8384",
  "payment-link-components": "/payment-link-components/static-1.22985",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9704",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23949",
  "viral-links-lib": "/viral-links-lib/static-1.6851",
  "data-token-picker": "/data-token-picker/static-1.16073",
  "FileManagerLib": "/FileManagerLib/static-1.38590",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5060",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17052",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8329",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.209",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91277",
  "crm-links": "/crm-links/static-1.6083",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45466",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15099",
  "crm-fe-perf": "/crm-fe-perf/static-1.22722",
  "calling-global-api": "/calling-global-api/static-1.63740",
  "calling-internal-common": "/calling-internal-common/static-1.31111",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65122",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57416",
  "commerce-products-lib": "/commerce-products-lib/static-1.8910",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.494",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4063",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.449",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48046",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3804",
  "property-value-citations": "/property-value-citations/static-1.1462",
  "pulse": "/pulse/static-1.332",
  "smart-property-lib": "/smart-property-lib/static-1.5981",
  "tiered-pricing": "/tiered-pricing/static-1.853",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10810",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1363",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6399",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11523",
  "content-media-compositions": "/content-media-compositions/static-2.15530",
  "media-bridge-lib": "/media-bridge-lib/static-1.18596",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5745",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4902",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3484",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21338",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3660",
  "audio-components": "/audio-components/static-1.5637",
  "FileManagerCore": "/FileManagerCore/static-1.38449",
  "FileManagerImages": "/FileManagerImages/static-1.36101",
  "video-components": "/video-components/static-1.12624",
  "crm_universal": "/crm_universal/static-1.21691",
  "customer-data-email": "/customer-data-email/static-1.17701",
  "calling-error-reporting": "/calling-error-reporting/static-1.31117",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36549",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38905",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18548",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11256",
  "customer-data-content": "/customer-data-content/static-1.26905",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54087",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20913",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17194",
  "project-storage": "/project-storage/static-1.4549",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71276",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5346",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5146",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9600",
  "policy-lib": "/policy-lib/static-1.6603",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10854",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6356",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.297",
  "commerce-permissions": "/commerce-permissions/static-1.575",
  "products-iframe-lib": "/products-iframe-lib/static-1.7365",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9899",
  "directed-graph": "/directed-graph/static-1.755",
  "event-emitter": "/event-emitter/static-1.763",
  "react-tinymce": "/react-tinymce/static-1.54668",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9663",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53794",
  "tinymce-plugins": "/tinymce-plugins/static-1.56908",
  "tinymce-themes": "/tinymce-themes/static-1.55764",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4348",
  "video-embed": "/video-embed/static-1.35113",
  "social-insights-client-types": "/social-insights-client-types/static-1.21413",
  "sequences-lib": "/sequences-lib/static-1.7714",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10163",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17983",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36482",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9841",
  "utility-belt": "/utility-belt/static-1.2356",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22072",
  "products-ui-components": "/products-ui-components/static-1.39429",
  "quotes-client-types": "/quotes-client-types/static-1.37365",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79996",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8927",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6751",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54103",
  "commerce-products-api": "/commerce-products-api/static-1.1980",
  "SafeStorage": "/SafeStorage/static-1.4220",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56161",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101953",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35074",
  "sales-views-client-types": "/sales-views-client-types/static-1.4103",
  "hub-http-contrib": "/hub-http-contrib/static-1.2859",
  "interframe": "/interframe/static-3.4605",
  "tinymce-data": "/tinymce-data/static-1.39879",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5029",
  "layout-dnd-components": "/layout-dnd-components/static-1.12069",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11044",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13982",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8911",
  "outpost": "/outpost/static-1.4022",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7571",
  "customer-data-associations": "/customer-data-associations/static-1.7154",
  "framework-data-table": "/framework-data-table/static-2.11456",
  "customer-data-rte": "/customer-data-rte/static-1.32488",
  "cv-backend-services": "/cv-backend-services/static-1.1505",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5391",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14271",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4930",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7164",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.333",
  "property-description-translator": "/property-description-translator/static-1.3674",
  "FireAlarmUi": "/FireAlarmUi/static-1.4347",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4006",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3472",
  "totals-ui-components": "/totals-ui-components/static-1.23043",
  "ContentData": "/ContentData/static-1.67749",
  "layout-data-lib": "/layout-data-lib/static-1.9369",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1308",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "draft-content-plugins": "/draft-content-plugins/static-1.27756",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3655",
  "advanced-menus-core": "/advanced-menus-core/static-1.14841",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11812",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33483",
  "deal-intel-utils": "/deal-intel-utils/static-1.1312",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14840",
  "simple-menus-lib": "/simple-menus-lib/static-1.16357"
}
};
